import { Component } from '@angular/core';
import { NavController, NavParams ,ToastController , ModalController} from 'ionic-angular';
import { Api } from '../../providers/api';
import { SearchCustomersPage } from '../search-customers/search-customers';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Headers , RequestOptions } from '@angular/http';
import {CartManager} from "../../providers/cart-manager";
import {SelectionSearchPage} from '../selection-search/selection-search';
import { SelectionSearchService } from '../../services/selection-search' ;
import {GVLogger} from '../../services/gv-logger';
import  {LoginPage} from '../login/login';
import { MsgManager } from '../../providers/msg-manager';

@Component({
  selector: 'page-create-customer',
  templateUrl: 'create-customer.html'
})
export class CreateCustomerPage {





  formStatus:boolean;

  customerCreateForm:any ;

  countriesList: any;

  stateList1: any;
  cityList1: any;

  stateList2: any;
  cityList2: any;

  address1Country:any;
  address1State:any;
  address1City:any = "";

  address2Country:string = "na";
  address2State:string = "na";
  address2City:string = "";

  taxGroupList:any;
  customerGroupList:any;
  paymentTermsList:any;

  intelliRepUsersList:any;
  intelliRepUser:string = "na";

  taxGroup:string = "na";
  customerGroup:string = "na";
  paymentTerms:string = "";


  states1SelectControl:boolean = false;
  cities1SelectControl:boolean = false;

  states2SelectControl:boolean = false;
  cities2SelectControl:boolean = false;

  ERROR_TEXT = "error";

  userNameError = "";

  nameError="";
  taxGroupError="";
  customerGroupError = "";

  cityError= " ";
  emailError = false;

  constructor(public cartManager:CartManager ,public navCtrl: NavController, public navParams: NavParams, public api:Api,
  	public toastController:ToastController, public formBuilder: FormBuilder, public modalController:ModalController,
    public ss:SelectionSearchService,
    private gVLogger:GVLogger,
    private msgManager:MsgManager) {

    this.ss.initializeService();
    this.getAllIntelliRepUsers();

    this.address1Country = this.ss.getCountry1();

    this.formStatus = false;
    this.loadPaymentTerms();
    this.loadTaxGroups();
    this.loadCustomerGroups();
  	this.customerCreateForm = this.formBuilder.group({
		company: this.paymentTerms,
    iUser:this.intelliRepUser,


      prefix: ["",Validators.compose([Validators.maxLength(30)])],
      name: ["",Validators.compose([Validators.maxLength(30)])],
      email: ["",Validators.compose([Validators.maxLength(30)])],
      password: ["",Validators.compose([Validators.maxLength(30)])],
      userName: ["",Validators.compose([Validators.maxLength(30)])],
      phoneCode: ["",Validators.compose([Validators.maxLength(30)])],
      phoneNumber: ["",Validators.compose([Validators.maxLength(30)])],
      taxGroup: this.taxGroup,
      customerGroup: this.customerGroup,
      isPrimary: [false],
      address1name:["",Validators.compose([Validators.maxLength(30)])],
      address1street:["",Validators.compose([Validators.maxLength(30)])],
      address1city:this.address1City,
      address1state:["",Validators.compose([Validators.maxLength(30)])],
      address1zip:["",Validators.compose([Validators.maxLength(30)])],
      address1country:this.address1Country,
      isSameAsAbove: [false],
      address2name:["",Validators.compose([Validators.maxLength(30)])],
      address2street:["",Validators.compose([Validators.maxLength(30)])],
      address2city:this.address2City,
      address2state:["",Validators.compose([Validators.maxLength(30)])],
      address2zip:["",Validators.compose([Validators.maxLength(30)])],
      address2country:this.address2Country
	});

    this.getLookupCountries();
  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad CreateCustomerPage');
  }

  createCustomer(){
  this.validateForm();
    if(this.formStatus){
      this.formStatus = false;

       var locations = [];
       // let locationShipto = {
       let locationBillto  = {
        receiverName:this.customerCreateForm.value.address1name,
        addressLine1: this.customerCreateForm.value.address1street,
        addressLine2: "",
        city: this.customerCreateForm.value.address1city,
        state: this.customerCreateForm.value.address1state,
        zipCode: this.customerCreateForm.value.address1zip,
        country: this.customerCreateForm.value.address1country,
        isShipToAddress: 1,
        locationType: "SHIPTO"
    }
    if(this.customerCreateForm.value.isSameAsAbove) {
      locationBillto.locationType = "BILLTOSHIPTO";
      locations.push(locationBillto);
    }else{
      // let locationBillto = {
      let locationShipto = {
        receiverName:this.customerCreateForm.value.address2name,
        addressLine1: this.customerCreateForm.value.address2street,
        addressLine2: "",
        city: this.customerCreateForm.value.address2city,
        state: this.customerCreateForm.value.address2state,
        zipCode: this.customerCreateForm.value.address2zip,
        country: this.customerCreateForm.value.address2country,
        isShipToAddress: 0,
        locationType: "BILLTO"
    }

      locations.push(locationShipto);
      locations.push(locationBillto);
    }

    var postJSON = {
     logedinUser: Number(this.cartManager.getSalesManId()),
     company: this.customerCreateForm.value.company,
     salesPersonCode: this.customerCreateForm.value.iUser,
     name: this.customerCreateForm.value.name,
     userName: this.customerCreateForm.value.userName,
     password: this.customerCreateForm.value.password,
     prefixCustomerId: this.customerCreateForm.value.prefix,
     phone: this.customerCreateForm.value.phoneCode + " " + this.customerCreateForm.value.phoneNumber,
     taxGroup: this.customerCreateForm.value.taxGroup,
     customerGroup: this.customerCreateForm.value.customerGroup,
     email: this.customerCreateForm.value.email,
     locationsDTOs: locations
    }


    this.gVLogger.log(postJSON);

let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });

    this.formStatus = false;
  this.api.post("customers/add",JSON.stringify(postJSON),options)
  .map(res => res.json())
    .subscribe(data => {
  if(data.status == "200"){
    this.msgManager.toastMsg("Customer Created");
    this.navCtrl.setRoot(SearchCustomersPage).then(()=>{this.navCtrl.push(SearchCustomersPage);});
  }else if(data.status == "401"){ // check for session out
      this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
      this.navCtrl.setRoot(LoginPage);
    }

   });

  this.gVLogger.log(JSON.stringify(postJSON));
    }else{
      this.presentToast("Please fill all the fields to continue.","bottom");
    }
  }


  getLookupCountries(){
    this.api.get("lookup/codesByTable?tableName=country").map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.countriesList = result.data;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });

  }


  country1Changed(){

    this.validateForm();

    let countryId = this.customerCreateForm.controls.address1country._value;

    this.api.get("lookup/codesByCode?codeString=" + countryId).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.stateList1 = result.data;
        this.cityList1 = [];
        // this.customerCreateForm.controls['address1state'].setValue("");
        this.customerCreateForm.controls['address1city'].setValue("");
        this.states1SelectControl = true;
        this.cities1SelectControl = false;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });


  }

  country2Changed(){

    this.validateForm();

    let countryId = this.customerCreateForm.controls.address2country._value;

    this.api.get("lookup/codesByCode?codeString=" + countryId).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.stateList2 = result.data;
        this.cityList2 = [];
        this.customerCreateForm.controls['address2state'].setValue("");
        this.customerCreateForm.controls['address2city'].setValue("");
        this.states2SelectControl = true;
        this.cities2SelectControl = false;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });

  }

  state1Changed(){

    this.validateForm();

    this.gVLogger.log("state1 changed");
    let provinceId = this.customerCreateForm.controls.address1state._value;

    this.api.get("lookup/codesByCode?codeString=" + provinceId).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.cityList1 = result.data;
        this.customerCreateForm.controls['address1city'].setValue("");
        this.cities1SelectControl = true;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });
  }

  state2Changed(){
     this.validateForm();
    let provinceId = this.customerCreateForm.controls.address2state._value;

    this.api.get("lookup/codesByCode?codeString=" + provinceId).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.cityList2 = result.data;
        this.customerCreateForm.controls['address2city'].setValue("");
        this.cities2SelectControl = true;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });
  }


  checkUsernameUniqeness(){

    this.gVLogger.log(this.customerCreateForm.controls.userName._value +" -- - - ");
   // var body:any = { "query":};

    let body = new FormData();
    body.append('query', this.customerCreateForm.controls.userName._value );

    let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });

      this.gVLogger.log(JSON.stringify(body));
    this.api.post('customers/availability',body)
      .map(res => res.json())
        .subscribe(resp => {
          this.gVLogger.log(JSON.stringify(resp));
          if(resp.status=="200"){
            this.formStatus = true;
            this.userNameError = "";
          }else if(resp.status=="500"){
            this.userNameError = this.ERROR_TEXT;
            this.formStatus = false;
            this.msgManager.toastMsg("Username not available please choose other.");
          }else if(resp.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.navCtrl.setRoot(LoginPage);
          }
        });
  }

  loadTaxGroups(){
    this.api.get("lookup/taxGroups").map(res => res.json()).subscribe(result =>{
      if(result.status == "200"){
        this.taxGroupList = result.data;
      }else if(result.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.navCtrl.setRoot(LoginPage);
          }
    });
  }

  loadCustomerGroups(){
    this.api.get("lookup/customerGroups").map(res => res.json()).subscribe(result =>{
      if(result.status == "200"){
        this.customerGroupList = result.data;
      }else if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.navCtrl.setRoot(LoginPage);
      }
    });
  }

  loadPaymentTerms(){
  // let body = new FormData();
  // body.append("tableName", "termsCode");

  this.api.get("lookup/codesByTable?tableName=termsCode").map(res => res.json()).subscribe(result =>{
      if(result.status == "200"){
        this.paymentTermsList = result.data;
      }else if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.navCtrl.setRoot(LoginPage);
      }
    });
  }



  nameChanged(){
    this.gVLogger.log("Name field changed")
    if(this.customerCreateForm.controls.name._value == ""){
      this.nameError = this.ERROR_TEXT;
      this.formStatus = false;
    }else{
      this.nameError = "";
      this.validateForm();
    }
  }

  taxGroupChanged(){
    this.gVLogger.log("taxGroup field changed")
    if(this.customerCreateForm.controls.taxGroup._value == "na"){
      this.taxGroupError = this.ERROR_TEXT;
      this.formStatus = false;
    }else{
      this.taxGroupError = "";
      this.validateForm();
    }
  }

   customerGroupChanged(){
     this.gVLogger.log("customer field changed")
    if(this.customerCreateForm.controls.customerGroup._value == ""){
      this.customerGroupError = this.ERROR_TEXT;
      this.formStatus = false;
    }else{
      this.customerGroupError = "";
      this.validateForm();
    }
  }

 city1Changed(){
     this.gVLogger.log("customer field changed")
    if(this.customerCreateForm.controls.address1city._value == "" ||
     this.customerCreateForm.controls.address1city._value == ""){
      this.cityError = this.ERROR_TEXT;
      this.formStatus = false;
    }else{
      this.cityError = "";
      this.validateForm();
    }
  }


  showModalCountry1(){

    this.ss.setItemsList(this.countriesList);
    this.gVLogger.log("countries : " );
    this.gVLogger.log(this.ss.getItemsList());
    this.ss.setVariableType("country1");
    let modal = this.modalController.create(SelectionSearchPage);
    modal.onWillDismiss(data => {
     this.gVLogger.log(data);
     if(data != null){
       if(data.viewType == "country1"){
         this.customerCreateForm.controls.address1country._value = data.item.code;
         this.customerCreateForm.controls['address1country'].setValue(data.item.code);
         this.gVLogger.log("code");
         this.gVLogger.log(data.item.code);
         this.gVLogger.log("code form");
         this.gVLogger.log(this.customerCreateForm.controls.address1country._value);
        this.country1Changed();
       }
     }
   });
    modal.present();
  }


  showModalState1(){
    if(this.states1SelectControl){
        this.ss.setItemsList(this.stateList1);
        //this.gVLogger.log("countries : ",  this.ss.getItemsList());
        this.ss.setVariableType("state1");
        let modal = this.modalController.create(SelectionSearchPage);
        modal.onWillDismiss(data => {
        // this.gVLogger.log("dismiss",data);
         if(data != null){
           if(data.viewType == "state1"){
             this.customerCreateForm.controls.address1state._value = data.item.code;
             this.customerCreateForm.controls['address1state'].setValue(data.item.code);
            this.state1Changed();
           }
         }
       });
        modal.present();
      }
    }

    showModalCiy1(){
    if(this.cities1SelectControl){
        this.ss.setItemsList(this.cityList1);
        this.ss.setVariableType("city1");
        let modal = this.modalController.create(SelectionSearchPage);
        modal.onWillDismiss(data => {
         if(data != null){
           if(data.viewType == "city1"){
             this.customerCreateForm.controls.address1city._value = data.item.code;
             this.customerCreateForm.controls['address1city'].setValue(data.item.code);
             this.validateForm();
           // this.state1Changed();
           }
         }
       });
        modal.present();
      }
    }

    showModalCountry2(){

    this.ss.setItemsList(this.countriesList);
   // this.gVLogger.log("countries : ",  this.ss.getItemsList());
    this.ss.setVariableType("country2");
    let modal = this.modalController.create(SelectionSearchPage);
    modal.onWillDismiss(data => {
    // this.gVLogger.log("dismiss",data);
     if(data != null){
       if(data.viewType == "country2"){
         this.customerCreateForm.controls.address2country._value = data.item.code;
         this.customerCreateForm.controls['address2country'].setValue(data.item.code);

        this.country2Changed();
       }
     }
   });
    modal.present();
  }


  showModalState2(){
    if(this.states2SelectControl){
        this.ss.setItemsList(this.stateList2);
        this.ss.setVariableType("state2");
        let modal = this.modalController.create(SelectionSearchPage);
        modal.onWillDismiss(data => {
         if(data != null){
           if(data.viewType == "state2"){
             this.customerCreateForm.controls.address2state._value = data.item.code;
             this.customerCreateForm.controls['address2state'].setValue(data.item.code);
            this.state2Changed();
           }
         }
       });
        modal.present();
      }
    }

    showModalCiy2(){
    if(this.cities2SelectControl){
        this.ss.setItemsList(this.cityList2);
       // this.gVLogger.log("countries : ",  this.ss.getItemsList());
        this.ss.setVariableType("city2");
        let modal = this.modalController.create(SelectionSearchPage);
        modal.onWillDismiss(data => {
       //  this.gVLogger.log("dismiss",data);
         if(data != null){
           if(data.viewType == "city2"){
             this.customerCreateForm.controls.address2city._value = data.item.code;
             this.customerCreateForm.controls['address2city'].setValue(data.item.code);
             this.validateForm();
           // this.state1Changed();
           }
         }
       });
        modal.present();
      }
    }

    validateForm(){
       this.gVLogger.log("validating form");
       this.gVLogger.log("this.customerCreateForm.controls.address1city._value" + this.customerCreateForm.controls.address1city._value);
       this.gVLogger.log("this.customerCreateForm.controls.address1name" + this.customerCreateForm.controls.address1name._value);
       this.gVLogger.log("this.customerCreateForm.controls.address1state._value" + this.customerCreateForm.controls.address1state._value);
       this.gVLogger.log("this.customerCreateForm.controls.email._value" + this.customerCreateForm.controls.email._value);
       this.gVLogger.log("this.customerCreateForm.controls.phoneCode._valu" + this.customerCreateForm.controls.phoneCode._value);
       this.gVLogger.log("this.customerCreateForm.controls.phoneNumber._value" + this.customerCreateForm.controls.phoneNumber._value);
       this.gVLogger.log("this.customerCreateForm.controls.name._value " + this.customerCreateForm.controls.name._value);
      if(
        this.customerCreateForm.controls.name._value != ""// Company Name

         ){

           // Form is verified
          this.formStatus = true;
        }else{

          this.formStatus = false;
        }

        this.gVLogger.log("Status: ");
        this.gVLogger.log(this.formStatus)

        this.gVLogger.log("Form :");
        this.gVLogger.log(this.customerCreateForm);

    }



    presentToast(msg,position) {
      let toast = this.toastController.create({
        message: msg,
        duration: 3000,
        position: position
      });
      toast.present();
    }


    getAllIntelliRepUsers(){

      this.api.get("lookup/salesperson/all").map(res => res.json()).subscribe(result =>{
        if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }else if(result.status == "200"){
          this.gVLogger.log("lookup/salesperson/all");
          this.gVLogger.log(result);
          this.intelliRepUsersList = result.data;
        }
      });

    }

}



// WEBPACK FOOTER //
// ./src/pages/create-customer/create-customer.ts